<script setup>
import {computed, defineProps} from 'vue';
import { RouterLink } from 'vue-router';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
const modules = [Navigation, Pagination];
const props = defineProps({
  data: {
    type: Object,
    default: () => {}
  },
  color: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    default: "0"
  }
});
const swiperOptions = computed(() => {
  return {
    modules: modules,
    slidesPerView: 'auto',
    spaceBetween: 0,
    // Медленнее дефолтных 300 мс: на широких карточках короткая прокрутка
    // читается как рывок.
    speed: 600,
    navigation: {
      nextEl: `.article-announce__slider-next_${props.id}`,
      prevEl: `.article-announce__slider-prev_${props.id}`,
      disabledClass: '_disabled'
    },
    pagination: {
      el: `.article-announce__pagination_${props.id}`,
      clickable: true,
    }
  }
})
</script>
<template>
  <div class="article-announce" :style="{'background-color': color}">
    <div class="article-announce__info">
      <h2 class="article-announce__info-title">{{ data.title }}</h2>
      <p class="article-announce__info-descr" v-html="data.descr"></p>
      <div class="article-announce__slider-nav">
        <span :class="['article-announce__slider-prev', `article-announce__slider-prev_${props.id}`]">
          <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.41406 1L1.41406 9L9.41406 17" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </span>
        <span :class="['article-announce__slider-next', `article-announce__slider-next_${props.id}`]">
          <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L9 9L1 17" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </span>
      </div>
    </div>
    <div class="article-announce__items">
      <Swiper
          v-bind="swiperOptions"
      >
        <SwiperSlide  v-for="item in data.items" :key="item.title">
          <!-- notReady — статья ещё не опубликована: карточка остаётся на
               месте с пометкой «скоро», но ссылкой не становится. -->
          <component
            :is="item.notReady ? 'div' : RouterLink"
            :class="['article-announce__item', {'_dark-text': item.darkText}]"
            :style="{'background-image': `url(${require('@/assets/img/articles/' + item.image)})`}"
            :to="item.notReady ? undefined : `/kakao-academy/${item.link}`"
          >
            <h4>
              <span>{{ item.type }}</span>
              <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="1.46189" cy="1.46189" r="1.46189" fill="white"/>
              </svg>
              <span>{{ item.time }}</span>
              <template v-if="item?.notReady">
                <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="1.46189" cy="1.46189" r="1.46189" fill="white"/>
                </svg>
                <span>скоро</span>
              </template>
            </h4>
            <h3 v-html="item.title"></h3>
          </component>
        </SwiperSlide>
      </Swiper>
    </div>
    <div :class="['article-announce__pagination', `article-announce__pagination_${props.id}`]"></div>
  </div>
</template>